module.exports = __webpack_public_path__ + "static/media/ADPlatform.1c124e55.png";